// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"04de2a75c6b41bbf","9190":"8f7d1c7b472fa8bb"}[chunkId] + ".css";
};